"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentBuilder = void 0;
const DeploymentBuilder_1 = require("./DeploymentBuilder");
exports.DeploymentBuilder = { buildEntity: DeploymentBuilder_1.buildEntity, buildEntityAndFile: DeploymentBuilder_1.buildEntityAndFile };
//# sourceMappingURL=index.js.map